var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8675 12.6457C14.8675 13.8732 13.8723 14.8685 12.6447 14.8685C11.4171 14.8685 10.4219 13.8732 10.4219 12.6457C10.4219 11.4181 11.4171 10.4229 12.6447 10.4229C13.8723 10.4229 14.8675 11.4181 14.8675 12.6457Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4007 5.92773H8.89247C7.25816 5.92773 5.92871 7.25718 5.92871 8.89149V16.3997C5.92871 18.034 7.25816 19.3634 8.89247 19.3634H16.4007C18.035 19.3634 19.3644 18.034 19.3644 16.3997V8.89149C19.3644 7.25718 18.035 5.92773 16.4007 5.92773ZM12.6466 16.3503C10.6038 16.3503 8.94186 14.6884 8.94186 12.6456C8.94186 10.6028 10.6038 8.94089 12.6466 8.94089C14.6894 8.94089 16.3513 10.6028 16.3513 12.6456C16.3513 14.6884 14.6894 16.3503 12.6466 16.3503ZM16.8946 9.13847C16.4854 9.13847 16.1537 8.80678 16.1537 8.39753C16.1537 7.98828 16.4854 7.65659 16.8946 7.65659C17.3039 7.65659 17.6356 7.98828 17.6356 8.39753C17.6356 8.80678 17.3039 9.13847 16.8946 9.13847Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6223 0H6.66845C2.99154 0 0 2.99154 0 6.66845V18.6223C0 22.2992 2.99154 25.2907 6.66845 25.2907H18.6223C22.2992 25.2907 25.2907 22.2992 25.2907 18.6223V6.66845C25.2907 2.99154 22.2992 0 18.6223 0ZM20.8451 16.3995C20.8451 18.8507 18.8507 20.8451 16.3995 20.8451H8.89127C6.44 20.8451 4.44564 18.8507 4.44564 16.3995V8.89127C4.44564 6.44 6.44 4.44564 8.89127 4.44564H16.3995C18.8507 4.44564 20.8451 6.44 20.8451 8.89127V16.3995Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgGrey);
export default __webpack_public_path__ + "static/media/ig_grey.5bc908497d639988e35eab16eb033386.svg";
export { ForwardRef as ReactComponent };